import React from 'react';
import classNames from 'classnames';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import { Button, EditableText, Switch } from '../../../../components';
import type { SwitchChangeEventHandler } from 'antd/es/switch';

import { BringgPopover } from '../../../../components';
import { menuIcon } from '../../rule/rule-utils';

import { FleetRuleHeaderHandlers, FleetRuleHeaderOptions } from '../fleet-rule-utils';

import styles from '../fleet-rule.module.scss';
import '../fleet-rule.scss';

export interface MenuContentProps {
	handleSettingsClick: FleetRuleHeaderHandlers['handleSettingsClick'];
	menuItems: FleetRuleHeaderOptions['settingsMenuItems'];
}

interface DefaultFleetRuleHeaderProps {
	fleetRuleHeaderOptions: FleetRuleHeaderOptions;
	fleetRuleHeaderHandlers: FleetRuleHeaderHandlers;
	className?: string;
	disabled?: boolean;
	isHovered?: boolean;
	inactiveText?: string;
	handleHovered: (value: boolean) => void;
	toggleSwitch?: SwitchChangeEventHandler;
}

const MenuContent = ({ handleSettingsClick, menuItems }: MenuContentProps) => (
	<div className={styles['popover-inner-panel']}>
		{menuItems.map(({ name, icon }, index) => {
			return (
				<div className={styles['dropdown-action-item']}>
					<BringgIcon className={styles['dropdown-icon']} iconName={BringgFontIcons[icon]} />
					<div
						className={styles['dropdown-text']}
						key={`${name}-${index}`}
						onClick={e => {
							e.stopPropagation();
							handleSettingsClick(name);
						}}
					>
						{name}
					</div>
				</div>
			);
		})}
	</div>
);

export const FleetRuleHeader = ({
	fleetRuleHeaderOptions,
	fleetRuleHeaderHandlers,
	className,
	isHovered = false,
	disabled,
	handleHovered,
	toggleSwitch
}: DefaultFleetRuleHeaderProps) => {
	const { index, name, placeholder, settingsMenuItems, isRuleEnabled } = fleetRuleHeaderOptions;
	const { onNameChange, handleSettingsClick } = fleetRuleHeaderHandlers;
	return (
		<div
			data-test-id="fleet-router-rule-header"
			className={className}
			onMouseEnter={() => {
				handleHovered(true);
			}}
			onMouseLeave={() => {
				handleHovered(false);
			}}
		>
			{isHovered && (
				<div className={styles['drag-icon']}>
					<BringgIcon iconName={BringgFontIcons.Drag} />
				</div>
			)}
			{index && <div className={styles['rule-index']}>{index}</div>}
			{onNameChange && (
				<EditableText
					className={classNames({ [styles['editable-text-disabled']]: disabled })}
					placeholder={placeholder}
					value={name}
					onValueChange={onNameChange}
				/>
			)}
			<div data-test-id="fleet-router-rule-headers-actions" className="fleet-router-rule-actions">
				{toggleSwitch ? (
					<Switch checked={isRuleEnabled} onChange={toggleSwitch} className="enabled-switch" />
				) : null}
				<div data-test-id="fleet-router-rule-header-popover" onClick={e => e.stopPropagation()}>
					<BringgPopover
						content={
							<MenuContent handleSettingsClick={handleSettingsClick} menuItems={settingsMenuItems} />
						}
						noArrow
					>
						<Button
							shape="circle"
							className="menu-button"
							icon={menuIcon}
							onClick={e => e.preventDefault()}
						/>
					</BringgPopover>
				</div>
			</div>
		</div>
	);
};
